import React,{useState,useEffect, useRef} from 'react';
import Section from './section';
import { Preferences } from '@capacitor/preferences';
import { Navbar, Nav, Container, Image, Offcanvas, ButtonGroup, ToggleButton, Button, Toast} from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';
import { isBrowser, isMobileSafari, isMobile, isIOS } from 'react-device-detect';
import { useLanguage } from '../i18n/LanguageContext';
import { loadAndParseXml } from '../i18n/xmlLoader';

function Home(props) {
  const { language, setLanguage, t, languages } = useLanguage();
  const [show, setShow] = useState(false);
  const [message, setMessage] = useState("");
  const [bgOption, setBgOption] = useState("starconnect");
  const [sectionItems, setItems] = useState([]);
  const [currentTopic, setTopic] = useState({topic:"", title:""});
  const [width, setWidth]   = useState(window.outerWidth);
  const [height, setHeight] = useState(window.outerHeight);
  var touchMoved = false;
  const inputEl = useRef(null);
  var myRef = React.createRef();

  const handleSelect = (selectedIndex, e) => {
    setShow(true);
  };

  const handleBgSelect = (key, e) => {
    setBgOption(key);
    props.onBgSelect(key);
  };

  function handleClose(){
    setShow(false);
  } 
 
  const updateDimensions = () => {
    setWidth(window.outerWidth);
    setHeight(window.outerHeight);
  }

  const rotation = () => {
    if (window.screen && window.screen.orientation){
      const {type, angle} = window.screen.orientation;
      if (type.indexOf("portrait") >= 0){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    else{
      var angle = window.orientation;
      if (angle == 0 || angle == 180){
        var newHeight = height;
        var newWidth = width;
        if (width > height){
          newHeight = width;
          newWidth = height;
        }
      }
      else{ //landscape
        var newHeight = height;
        var newWidth = width;
        if (height > width){
          newHeight = width;
          newWidth = height;
        }
      }
      //alert("rotation type: " + type + " ,angle: " + angle + " ,currentWidth: " + width + " setWidth:[" + newWidth + "]");
      setWidth(newWidth);
      setHeight(newHeight);
    }
    
  }

  function handleClick(topic, displayTitle, desc){
    setTopic({topic:topic, title:displayTitle, desc:desc});
  }

  function handleBack(){
    setTopic({topic:"", title:""});
  }

  useEffect(() => {
    loadAndParseXml('guide.xml', language, function (err, result) {
      if (err) {
        alert(t('common.cannotReadGuide'));
        return;
      }
      try{
          var sections = result.sections.section;
          var listItems = sections.map(function(section, index){
            var key = section.$.key;
            var title = section.title[0];
            var icon = section.icon[0];
            var desc = section.desc[0];
            var short = section.short[0];
            var icon2 = section.iconsmall[0];
      
            return (
             {key:key, title:title, icon:icon, desc:desc, short:short, icon2:icon2}
            )
          });
          setItems(listItems);
      }
      catch(ex){
        alert(t('common.cannotReadGuide'));
      }
    });
  }, [language]);

  useEffect(() => {

    if (isMobile){
      if (window.screen && window.screen.orientation){
        window.screen.orientation.addEventListener("change", rotation);
      }
      else{
        window.addEventListener("orientationchange", rotation);
      }
    }
    else{
      window.addEventListener("resize", updateDimensions);
    }
    
    return function(){
      if (isMobile){
        if (window.screen && window.screen.orientation){
          window.screen.orientation.removeEventListener("change", rotation);
        }
        else{
          window.removeEventListener("orientationchange", rotation);
        }
      }
      else{
        window.removeEventListener("resize", updateDimensions);
      }
    } 
  },[] );

  function getSectionItems(){
    //<FontAwesomeIcon icon={faChevronRight} color="#D5A3FF" size='1x' />
    return sectionItems.map(function(section, index){
     
      var imgWidth = width * 0.4;
      if (imgWidth > 250){
        imgWidth = 250;
      }
      if (index  % 2 == 0){
       
              return (<div className="cardleft" onClick={handleClick.bind(this, section.key, section.title, section.desc)}
              onTouchEnd={function(){
                if (touchMoved == false){
                 handleClick(section.key, section.title, section.desc);
                }
              }}
              onTouchMove={function(){
                touchMoved = true;
              }}
              onTouchStart={function(){
               touchMoved = false;
             }}>    
              <div>
                <img
                  src={section.icon}
                  alt={section.title}
                  width={imgWidth + "px"}
                />
              </div>
              <div className="cardtext justify-content-center align-self-center mx-auto">
                <div className="c1">{section.title}</div>
                <div className="c2">{section.desc}</div>
              </div>
              <a class="card-control-next" role="button" tabindex="0"><span aria-hidden="true" class="carousel-control-next-icon"></span><span class="visually-hidden">{t('common.next')}</span></a>
          </div>
        )
      }
      else{
        return (<div className="cardright" onClick={handleClick.bind(this, section.key, section.title, section.desc)}
        onTouchEnd={function(){
          if (touchMoved == false){
           handleClick(section.key, section.title, section.desc);
          }
        }}
        onTouchMove={function(){
          touchMoved = true;
        }}
        onTouchStart={function(){
         touchMoved = false;
       }}>    
              <a class="card-control-prev" role="button" tabindex="0"><span aria-hidden="true" class="carousel-control-prev-icon"></span><span class="visually-hidden">{t('common.previous')}</span></a>
              <div className="cardtext justify-content-center align-self-center mx-auto">
                <div className="c1">{section.title}</div>
                <div className="c2">{section.desc}</div>
              </div>
              <div>
                <img
                  src={section.icon}
                  alt={section.title}
                  width={imgWidth + "px"}
                  />
              </div>
          </div>
        )
      }
      
     
    });
  }

  async function handleCopy(){
    //Get the saved cards and copy to clipboard
   //https://capacitorjs.com/docs/apis/storage
   setMessage(t('settings.copying'));
   var keys = await Preferences.keys();
   var itemKeys = (keys && keys.keys) ? keys.keys.filter(function(k){ return /^\d+$/.test(k); }) : [];
   var cardItemsRaw = await Promise.all(itemKeys.map(async (key) => {
     try {
       var itemJson =  await Preferences.get({ key: key });
       if (!itemJson || !itemJson.value) return null;
       JSON.parse(itemJson.value);
       return itemJson;
     } catch (e) {
       return null;
     }
   }));
   var cardItems = cardItemsRaw.filter(Boolean);
   var str = JSON.stringify(cardItems);
   navigator.clipboard.writeText(str).then(function () {
      setMessage(t('settings.savedCopied', { count: cardItems.length }));
    }, function (err) {
      //Error, just write to text box
      if (cardItems.length >0){
        inputEl.current.value = str
        setMessage(t('settings.savedWritten', { count: cardItems.length }));
      }
      else{
        setMessage(t('settings.zeroSavedWritten'));
      }
    });
  
   Promise.resolve();
  }

  async function handleImport(){
    //Get the saved cards and copy to clipboard
    setMessage(t('settings.importing'));
    
      try{
        var cardItems;
        try{
          var pasteData = inputEl.current.value;
          cardItems = JSON.parse(pasteData);
        }
        catch(e){
          setMessage(t('settings.invalidString', { preview: pasteData ? pasteData.substring(0,20) : '' }));
        }
        
        if (cardItems && cardItems.length >0){
          var count = 0;
          const forLoop = async _ => {
            console.log('Start')
            for (let index = 0; index < cardItems.length; index++) {
              try{
                var c = cardItems[index];
                if (!c || !c.value) continue;
                var card = JSON.parse(c.value);
                console.log('card key: ' + card.key);
                if (card.key && /^\d+$/.test(card.key.toString())){
                  console.log('calling storage get: ' + card.key);
                  var itemJson =  await Preferences.get({ key: card.key.toString()});
                  if (!itemJson.value){
                    count++;
                    console.log('calling storage set for ' + card.key);
                    await Preferences.set({
                      key: card.key.toString(),
                      value: JSON.stringify(card),
                    });
                  }
                  else{
                  //skip
                  console.log('skip');
                  }
                }
              }
              catch(e){
                setMessage(t('settings.importFailed', { error: e.toString() }));
              }  
            
              if (count == 1){
                setMessage(t('settings.addedOneItem'));
              }
              else{
                setMessage(t('settings.addedMultipleItems', { count }));
              }
            }
          }
          forLoop();
      }
      }
      catch(e){
        setMessage(t('settings.importFailed', { error: e.toString() }));
      }
  
  }


  function getSettings(){
   
    const radios = [
      { name: t('settings.starlink'), value: 'starconnect' },
      { name: t('settings.star'), value: 'star' },
      { name: t('settings.static'), value: 'static' },
    ];

    const funs = [
      { name: t('settings.portal'), value: 'portal' },
      { name: t('settings.amongUs'), value: 'among' }
    ];

    //Load saved cards

    return (
    <Offcanvas className="semibackground setting" show={show} onHide={handleClose} {...props} placement={'end'}>
    <Offcanvas.Header style={{paddingTop:'calc(env(safe-area-inset-top))'}} closeButton>
      <Offcanvas.Title><div style={{color:'white'}}>{t('settings.title')}</div></Offcanvas.Title>
    </Offcanvas.Header>
    <Offcanvas.Body style={{paddingTop:0}}>
    <div style={{paddingBottom:15}}>
      <div style={{color:'cornflowerblue'}}>{t('settings.language')}</div>
      <div style={{paddingTop:10}}>
        <ButtonGroup className="mb-2 d-flex flex-wrap">
          {languages.map((lang) => (
            <ToggleButton
              key={lang.code}
              id={`lang-${lang.code}`}
              type="radio"
              variant="secondary"
              name="langRadio"
              value={lang.code}
              checked={language === lang.code}
              onChange={(e) => setLanguage(e.currentTarget.value)}
              style={{flex: '1 1 45%', margin: '2px', textAlign: 'center'}}
            >
              {lang.nativeName}
            </ToggleButton>
          ))}
        </ButtonGroup>
      </div>
    </div>
    <div>
     <div style={{color:'cornflowerblue'}}>{t('settings.background')}</div>
      <div style={{paddingTop:10}}>
        <ButtonGroup className="mb-2">
            {radios.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-${idx}`}
                type="radio"
                variant="secondary"
                name="radio"
                value={radio.value}
                checked={bgOption === radio.value}
                onChange={(e) => handleBgSelect(e.currentTarget.value)}
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
      </div>
      </div>
      <div style={{paddingTop:25}}>
     <div style={{color:'cornflowerblue'}}>{t('settings.fun')}</div>
     <div style={{paddingTop:10}}>
     <ButtonGroup className="mb-2">
        {funs.map((fun, idx) => (
          <ToggleButton
            key={idx}
            id={`fun-${idx}`}
            type="radio"
            variant="secondary"
            name="fun"
            value={fun.value}
            checked={bgOption === fun.value}
            onChange={(e) => handleBgSelect(e.currentTarget.value)}
          >
            {fun.name}
          </ToggleButton>
        ))}
      </ButtonGroup>
      </div>
    </div>
    <div style={{paddingTop:30}}>
    <div style={{color:'cornflowerblue'}}>{t('settings.exportImport')}</div>
    <Button variant="secondary" onClick={(e) => handleCopy()}>{t('settings.copySaved')}</Button>{' '}
    </div>
    <div style={{paddingTop:10}}>
    <Button variant="secondary" onClick={(e) => handleImport()}>{t('settings.importSaved')}</Button>{' '}
    </div>
    <div style={{paddingTop:10}}>
    <textarea id="textareabox" ref={inputEl} name="textarea1" placeholder={t('settings.pastePlaceholder')} style={{width:'100%', height:'90px'}}></textarea>
    </div>
    <div style={{color:'cornflowerblue'}}>
      <label>{message}</label>
    </div>
    </Offcanvas.Body>
  </Offcanvas>
    )
  }
  if (currentTopic.topic != ""){
    return (
        <Section onBackSelected={handleBack} theme={props.theme} topic={currentTopic.topic} title={currentTopic.title} desc={currentTopic.desc}/>
        );
  } 
  else{
    var cHeight = '100vh';
    if (isBrowser || isMobileSafari){
      cHeight = height + 'px';
    }

    return (
    <div>
        <Navbar fixed="top" bg={props.theme} variant={props.theme} style={{paddingTop:'calc(env(safe-area-inset-top) + 10px)'}}>
            <Container>
            <Nav style={{width: "100%"}} className="justify-content-between" onSelect={handleSelect}>
            <Navbar.Brand href="#home" >
              <b>{t('app.title')}</b>
            </Navbar.Brand>
            <Nav.Link eventKey="settings" className="justify-content-end"><FontAwesomeIcon icon={faCog}  size='1x'/></Nav.Link>
            </Nav>
            </Container>
        </Navbar>
        <Container fluid style={{paddingTop:'75px',paddingBottom:'85px', overflow:'auto', height:'calc(' + cHeight + ' - 75px - env(safe-area-inset-top))'}}>
          <div>
          {getSectionItems()}
          </div>
          {getSettings()}
        </Container>
    </div>
     
  )
  }
};

export default Home;